// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"94":"d93e91a4","443":"b538fddf","461":"3c8d0748","680":"c9bfe647","813":"56e8caac","878":"a5d39c9a","971":"a24e5f6c"}[chunkId] + ".css";
};